The identifier for the `HiringOrganization`.
